import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  partner: {
    id: `app.containers.WorkflowEditor.components.Rules.Action.components.ResetPartnerStatus.partner`,
    defaultMessage: 'Partner',
  },
});
